import React from 'react';
import { Icon, Header, Portal } from 'semantic-ui-react';
import { PhoneUtil } from 'utils';
import './index.scss';
import { ClippedContent } from '../ClippedContent';
import { DragOverlay, useDraggable } from '@dnd-kit/core';
import DragHandle from '../DragHandle';
import DraggableCall from 'dyl-components/molecules/DraggableCall';
import phoneUtils from "utils/PhoneUtil";

const Line = ({ line, currentTime = 0, onSelectCall, onUnholdCall, onAnswer, onReject, answerDisabled, userPhoneCreds }) => {
    const isInternal = line.direction === "internal";
    const call_uuid = line.call_type === "transfer" ? line.channel_uuid : line.uuid;
    const leg = line.call_type === "dialphone" && line.direction === "outbound" ? line.legs?.find(l => !l.extension) : line?.legs?.find(leg => leg.channel_uuid === call_uuid);
    const phoneNumber = line?.company_destination?.substr(0,1) === "7" ? line?.company_destination : isInternal ? line?.legs?.find(leg => leg.channel_uuid !== line.uuid)?.extension : leg?.phone;
    const isHardPhone = !!!line?.session_id;
    const isActive = line.connected > 0;
    const ticker = PhoneUtil.timeTicker(
        currentTime > 0 ?
            currentTime - line.connected + (line.drift || 0)
            : 0
    );
    const { attributes, listeners, setNodeRef, isDragging, setActivatorNodeRef } = useDraggable({
        id: call_uuid,
        data: {
            source: "additional-line",
            phone: phoneNumber,
            channel_uuid: phoneUtils.contactLeg(line, userPhoneCreds)?.channel_uuid,
            caller_id_name: line.name,
            pbx: line.pbx,
            isInternal
        }
    });
    const dragHandle = <DragHandle {...attributes} {...listeners} ref={setActivatorNodeRef} disabled={isInternal}/>;
    return (
        <>
            <div className={`OfficeView__AdditionalLine${isHardPhone ? '--hardphone' : line.actionButtons?.hold ? '--hold' : isActive ? '--active' : '--ringing'}`} ref={setNodeRef} data-uuid={call_uuid}>
                <div className='OfficeView__LineLeft'>
                    {dragHandle}
                    <Icon size='large' className={`fa-solid fa-phone-${isActive? 'plus' : 'volume'} OfficeView__Phone`}/>
                </div>
                <div className='OfficeView__LineMiddle' onClick={() => onSelectCall(line.uuid, phoneNumber)}>
                    <ClippedContent popup={false}>
                        <Header as='h3' style={{fontWeight: 100, marginLeft: 15}}><a>{line.name}</a></Header>
                    </ClippedContent>
                </div>
                <div className='OfficeView__LineRight'>
                {isActive ? (
                    <>
                    <Header as='h3' style={{fontWeight: 100, display: 'inline-block', margin: 0 }}>
                        {ticker}
                    </Header>
                    {line.actionButtons?.hold && (
                        <Icon size='large' className='fa-solid fa-play OfficeView__Hold' onClick={() => onUnholdCall(line.uuid, line.session_id, phoneNumber)}/>
                    )}
                    </>
                ) : (
                    <>
                        <Icon size='large' className='fa-solid fa-phone OfficeView__Answer' disabled={answerDisabled} onClick={() => onAnswer(line.uuid, line.channel_uuid, line.session_id, phoneNumber)} />
                        <Icon size='large' className='fa-solid fa-phone-hangup OfficeView__Reject' onClick={() => onReject(line.uuid, line.channel_uuid)} />
                    </>
                )}
                </div>
            </div>
            <Portal open={isDragging}>
                <DragOverlay>
                    <DraggableCall 
                        dragHandle={dragHandle}
                        duration={isActive ? ticker : null}
                        personDisplay={line.name}
                        isRinging={!isActive}
                    />
                </DragOverlay>
            </Portal>
        </>
    )
}

export default Line;

